export function formatNumberWithSpaces(number: number | string | null | undefined) {
  return number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
